import { Grid } from '@mui/material'
import { useEffect } from 'react'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { ControlledTextField, AsyncSelect } from 'src/components/forms'
import { SectionBox } from 'src/pages/sistema/components/FieldView'
import { OperacionNOTESFields } from '../types/fields'
import CardActions from '../../../components/CardActions'
import { OpcionSiNo, useSiNoOptions } from '../../adcm/hooks/useOpcionesGenericas'

interface SeccionNOTESNuevoSeccionParticipacionProps {
  formMethods: UseFormReturn<any>
}

const SeccionNOTESNuevoSeccionParticipacion = ({ formMethods }: SeccionNOTESNuevoSeccionParticipacionProps) => {
  const { control, setValue, trigger } = formMethods
  const loadSiNo = useSiNoOptions()

  const watchedTieneParticipacion = useWatch({ control, name: OperacionNOTESFields.TieneParticipacion })

  useEffect(() => {
    if (watchedTieneParticipacion === OpcionSiNo.No) {
      setValue(OperacionNOTESFields.Participacion, '')
      setValue(OperacionNOTESFields.FormaParticipacion, '')
      setValue(OperacionNOTESFields.DescripcionParticipacion, '')
      setValue(OperacionNOTESFields.ObsParticipacion, '')
    }
    if (watchedTieneParticipacion === OpcionSiNo.Si) {
      trigger([
        OperacionNOTESFields.Participacion,
        OperacionNOTESFields.FormaParticipacion,
        OperacionNOTESFields.DescripcionParticipacion
      ])
    }
  }, [watchedTieneParticipacion, setValue, trigger])

  return (
    <CardActions title='Sección Participación o Garantía de Capital' icon='mdi:account-group-outline' colapsable>
      <SectionBox>
        <Grid item xs={12} md={4}>
          <AsyncSelect
            label='¿Tiene participación?'
            name={OperacionNOTESFields.TieneParticipacion}
            loadOptions={loadSiNo}
            control={control}
            fullWidth
            selectNotNulleable
          />
        </Grid>

        {watchedTieneParticipacion === OpcionSiNo.Si && (
          <>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Participación' 
                name={OperacionNOTESFields.Participacion} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Forma de participación' 
                name={OperacionNOTESFields.FormaParticipacion} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Descripción de la participación' 
                name={OperacionNOTESFields.DescripcionParticipacion} 
                control={control} 
                fullWidth 
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField 
                label='Observaciones adicionales' 
                name={OperacionNOTESFields.ObsParticipacion} 
                control={control} 
                fullWidth 
                multiline 
                rows={2} 
              />
            </Grid>
          </>
        )}
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNOTESNuevoSeccionParticipacion